import { render, staticRenderFns } from "./hot_production.vue?vue&type=template&id=0dfdddae&scoped=true"
import script from "./hot_production.vue?vue&type=script&lang=js"
export * from "./hot_production.vue?vue&type=script&lang=js"
import style0 from "./hot_production.vue?vue&type=style&index=0&id=0dfdddae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfdddae",
  null
  
)

export default component.exports